import { NavLink, useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { RUTA_ARCHIVOS } from '../api/client';
import {
    FiHome, FiBookOpen, FiAward, FiUser, FiSearch, FiSun, FiMoon,
    FiLogOut, FiSettings, FiUsers, FiBookmark, FiBarChart2, FiPlay
} from 'react-icons/fi';

function Avatar({ usuario, tamano = '' }) {
    const iniciales = (usuario?.nombre?.[0] || '') + (usuario?.apellido_paterno?.[0] || '');
    if (usuario?.imagen_perfil) {
        return <img className={`avatar ${tamano}`} src={`${RUTA_ARCHIVOS}${usuario.imagen_perfil}`} alt="avatar" />;
    }
    return <div className={`avatar ${tamano}`}>{iniciales.toUpperCase()}</div>;
}

export default function Layout() {
    const { usuario, logout } = useAuth();
    const { tema, cambiarTema } = useTheme();
    const navigate = useNavigate();

    const cerrarSesion = async () => {
        await logout();
        navigate('/login');
    };

    const esAdmin = usuario?.rol === 'administrador';

    return (
        <div className="app-layout">
            <aside className="sidebar">
                <div className="sidebar-logo">
                    <div style={{
                        width: 36, height: 36, borderRadius: 10,
                        background: 'linear-gradient(135deg, var(--acento), var(--acento-fuerte))',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff'
                    }}>
                        <FiPlay size={18} />
                    </div>
                    <h2>Chucho</h2>
                </div>
                <nav className="sidebar-nav">
                    <div className="seccion">Aprender</div>
                    <NavLink to="/dashboard" end className={({ isActive }) => isActive ? 'activo' : ''}>
                        <FiHome /> <span className="txt">Inicio</span>
                    </NavLink>
                    <NavLink to="/cursos" className={({ isActive }) => isActive ? 'activo' : ''}>
                        <FiBookOpen /> <span className="txt">Cursos</span>
                    </NavLink>
                    <NavLink to="/mis-cursos" className={({ isActive }) => isActive ? 'activo' : ''}>
                        <FiBookmark /> <span className="txt">Mis Cursos</span>
                    </NavLink>
                    <NavLink to="/perfil" className={({ isActive }) => isActive ? 'activo' : ''}>
                        <FiUser /> <span className="txt">Mi Perfil</span>
                    </NavLink>
                    <NavLink to="/perfil/certificados" className={({ isActive }) => isActive ? 'activo' : ''}>
                        <FiAward /> <span className="txt">Certificados</span>
                    </NavLink>

                    {esAdmin && (
                        <>
                            <div className="seccion">Administracion</div>
                            <NavLink to="/admin" end className={({ isActive }) => isActive ? 'activo' : ''}>
                                <FiBarChart2 /> <span className="txt">Panel</span>
                            </NavLink>
                            <NavLink to="/admin/profesores" className={({ isActive }) => isActive ? 'activo' : ''}>
                                <FiUsers /> <span className="txt">Profesores</span>
                            </NavLink>
                            <NavLink to="/admin/cursos" className={({ isActive }) => isActive ? 'activo' : ''}>
                                <FiBookOpen /> <span className="txt">Cursos</span>
                            </NavLink>
                            <NavLink to="/admin/reportes" className={({ isActive }) => isActive ? 'activo' : ''}>
                                <FiBarChart2 /> <span className="txt">Reportes</span>
                            </NavLink>
                        </>
                    )}
                </nav>
                <div className="sidebar-bottom">
                    <button className="btn btn-fantasma btn-bloque" onClick={cambiarTema}>
                        {tema === 'oscuro' ? <FiSun /> : <FiMoon />}
                        <span className="txt">{tema === 'oscuro' ? 'Tema claro' : 'Tema oscuro'}</span>
                    </button>
                </div>
            </aside>

            <div className="contenido-principal">
                <header className="topbar">
                    <div className="topbar-busqueda">
                        <FiSearch className="icono" size={16} />
                        <input placeholder="Buscar cursos..." />
                    </div>
                    <div className="topbar-acciones">
                        <button className="icon-btn" onClick={() => navigate('/perfil/configuracion')} title="Configuracion">
                            <FiSettings size={18} />
                        </button>
                        <button className="icon-btn" onClick={cerrarSesion} title="Cerrar sesion">
                            <FiLogOut size={18} />
                        </button>
                        <div className="user-chip" onClick={() => navigate('/perfil')}>
                            <Avatar usuario={usuario} />
                            <span style={{ fontSize: 13 }}>{usuario?.nombre} {usuario?.apellido_paterno}</span>
                        </div>
                    </div>
                </header>
                <main className="contenido">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}

export { Avatar };
